import React, {useState, useRef, useEffect, useMemo, useCallback, Fragment, useContext} from 'react';

import { VisDiv } from '..';
import { InsertProduct } from './InsertProduct';
import { sortByLocation } from '../../lib/utils'; 
import Swal from "sweetalert2"
import { IoIosAddCircleOutline } from 'react-icons/io';
import useMediaQuery from '../../hooks/useMediaQuery';
import { generatedOfferDoc, generatedOfferWithTotalsDoc } from '../gestioneDatabase/Docs';
import { EditableProduct } from './EditableProduct';
import TestButton from '../frontend_components/TestButton';

/**
 * A component that renders a list of editable products. It takes in a list of products, a register data object, a register 
 * template data object, and an edit boolean value. It also takes in an item data object, a setItem function to update the item data object,
 * a commonStyle object, a setVisible function to update the visibility of the component, and an offer data object. It renders a list of products, 
 * and a button to add new lines. When the button is clicked, it calls the setItem function with a new item data object containing the updated list of products. 
 * It also renders an insert product component, which is visible only if the register data object is not null. The insert product component takes in a save function, 
 * which is called when the component is submitted. The save function takes in the updated data array, and updates the item data object with the new array.
 * 
 * @param {array} groupProducts - The list of products to render.
 * @param {object} nonConformities - The non conformity data object.
 * @param {object} register - The register data object.
 * @param {object} registerTemplate - The register template data object.
 * @param {object} item - The item data object.
 * @param {function} setItem - A function to update the item data object.
 * @param {object} commonStyle - The common style object.
 * @param {function} setVisible - A function to update the visibility of the component.
 * @param {boolean} edit - A boolean value indicating whether the component is being edited.
 * @param {object} offer - The offer data object.
 * @param {function} updatedOffer - A function to update the offer data object.
 * @param {function} updateDataArray - A function to update the data array.
 * @param {array} dataArray - The data array.
 * @param {boolean} screenSizeDesktop - A boolean value indicating whether the screen size is desktop.
 */
export const EditableProducts = ({ groupProducts, nonConformities, register, registerTemplate, item, setItem, commonStyle, isVisible, edit, offer, updatedOffer, updateDataArray, dataArray}) => {
  
    const screenSizeDesktop = useMediaQuery("(min-width: 1540px)")
  
/*     const groupProducts = item?.fieldsIds?.map?.((id)=>{
      const product = !Array.isArray(dataArray) ? undefined : dataArray?.find?.((y)=>y?._id == id)
      return product
  }).filter?.((t)=>t) */
  
    const consoleData = {
      item,
      dataArray,
      offer
    }
  
    const addNewLine = (e) => {
      e.stopPropagation();
  
      console.log("ADD LINE", register)
      
    }
    const saveDocs = (data) => {
      //data.stopPropagation();
      
      const offerDocs = data?.map?.((x)=>generatedOfferDoc(x))
      const offerDocsWithTotals = offerDocs?.map?.((x)=>generatedOfferWithTotalsDoc(x))
      const updatedDataWithTotals = [...dataArray, ...offerDocsWithTotals]
      const fieldIds = item?.fieldsIds?.length < 1 ? [] : item?.fieldsIds
      const quantity = [...groupProducts, ...offerDocs]?.map?.((doc)=>Number(doc?.quantity))?.reduce((partialSum, a) => partialSum + a, 0)
      const newItem = {...item, quantity: quantity, fieldsIds: [...fieldIds, ...offerDocs?.map?.((x)=>x?._id)]}
      console.log("save docs", updatedDataWithTotals, newItem)
      
      updateDataArray(updatedDataWithTotals)
      setItem(newItem)
      //(updatedDraggableArray?.filter?.(x=>x)?.sort(sortByOrder))
      const updatedOfferDoc = {...offer, offerFields:[...offer?.offerFields, ...offerDocs ]}
      updatedOffer(updatedOfferDoc)
    }
  
    return (
      <VisDiv rules={[isVisible]}>
        <TestButton message="Test Editable Products" buttonId='kqpkdpqowkdd034' consoleData={consoleData} />
        <VisDiv rules={[register, false]} className='round-back-button' style={{backgroundColor:"white"}} onClick={(e) => {addNewLine(e)}}> 
          <IoIosAddCircleOutline fontSize={30} />
        </VisDiv>
        <VisDiv style={{zIndex:"1000"}} rules={[register]} >
          <InsertProduct saveFn={saveDocs} commonStyle={commonStyle} data={{register, nonConformities, existingProducts: groupProducts }} />
        </VisDiv>
        <div style={{marginLeft:"35px"}}>
          <EditableProductHeader commonStyle={commonStyle} edit={edit}/>
        </div>
       {
        groupProducts
        ?.sort(sortByLocation)
        ?.map?.((pr, index, array)=>{
          const groupData = {pr, index, item, commonStyle, edit, offer, updatedOffer, updateDataArray, dataArray, screenSizeDesktop, groupProducts:array, register, registerTemplate, nonConformities}
          return ( <EditableProduct key={pr?._id} data={groupData}/>)
        })
       }
      </VisDiv>
    )
  }
  export const EditableProductHeader = ({commonStyle, edit, isLabour}) => {
    const screenSizeDesktop = useMediaQuery("(min-width: 1540px)")
    return(
      <div style={{backgroundColor:"#385391", fontSize:"12px", fontWeight:"500", color:"white", display:"flex", }} >
        <VisDiv style={{...commonStyle(edit), textAlign:"center"}}>
          {"COD."}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          {"NORMATIVA DI RIFERIMENTO PER L'ADEMPIMENTO AGLI OBBLIGHI DEI PRESIDI ATTREZZATURE E SISTEMI"}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          {"DESCRIZIONE"}
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle(edit), flex:1.2, minWidth: "85px"}}>
          <span>
           {"UBICAZIONE"}
          </span>
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle(edit)}}>
          {"Q.TA’"}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit)}}>
          {"PREZZO CAD."}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit)}}>
          {"SCONTO %"}
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle(edit)}}>
          {"PREZZO CAD. SCONTATO"}
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle()}}>
          {"TOTALE"}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit), backgroundColor:"red"}}>
          {"PREZZO FORNITORE"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"TOTALE COSTO"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"MARGINE"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"PROFITTO"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"PROFITTO CAD."}
        </VisDiv>
        <VisDiv  rules={[false, screenSizeDesktop, !edit || isLabour]} style={{...commonStyle(edit), backgroundColor:"red"}}>
          {"MANO D'OPERA"}
        </VisDiv>
    </div>
    )
  }